'use strict';

import {
    fnErrorMsg,
    getSelectedRowData, printResponse, setMissingVoucherText,
    subLangPlaceHolder
} from "../jquery-functions-library";
import {element_exists} from "../functions";

export var fnIgnoreSelectedVouchers = function () {


    var tableName = '#datatable-vouchers';

    if (!element_exists(tableName)) return false;

    var lang = allLangFiles.vouchers;

    var btnIgnore = $('#btn-ignore-selected-vouchers');

    btnIgnore.off('click').on('click', function (e) {

        $(this).parent().parent('.dropdown.open').removeClass('open');

        var dataTable = $(tableName).DataTable();
        var selectedRowData = getSelectedRowData(dataTable);

        var data = [];

        var texts = [];
        var invalidSelections = [];

        $.each(selectedRowData, function (index, voucher) {

            console.log(voucher);
            if (voucher.valid_for_ignoring) {
                data.push(voucher.id);
                texts.push('#' + voucher.VoucherNumber);
            }
            /*reset and return if any selections have been uploaded*/
            else {
                invalidSelections.push('#' + voucher.VoucherNumber);
            }
        });


        if (invalidSelections.length) {
            toastr.warning(
                subLangPlaceHolder(lang.select.ignore_confirm.invalid, ':body', '<br>' + invalidSelections.join(',')+'<br>')
            );
            data = [];
            return false;
        }

        if (data.length) {

            var content = subLangPlaceHolder(lang.select.ignore_confirm.content+' '+lang.select.ignore_confirm.description, ':body', '<br>' + texts.join(',') + '<br>');

            $.confirm({
                title: lang.select.ignore_confirm.title,
                content: content,
                theme: 'supervan',
                columnClass: 'col-md-12',
                backgroundDismiss: true,
                buttons: {
                    Ja: {
                        action: function () {

                            $.ajax({
                                type: 'POST',
                                url: '/voucher/ignore/selection',
                                data: {ids: data},
                                success: function (response) {
                                    printResponse(response);
                                    dataTable.ajax.reload(function () {
                                        setMissingVoucherText();
                                    }, false);
                                },
                                error: fnErrorMsg
                            });
                        },
                        text: lang.yes
                    },
                    Nej: {
                        text: lang.no
                    },
                }
            });
        }
    });
};